import { ValidationError } from "@common/types";

export class EvalModelEditorViewModel
{
    opened: boolean = false;

    id: number | null = null;
    name: string | null = null;
    operationInProgress: boolean = false;

    errors: ValidationError[] = [];

    show(id: number, name: string)
    {
        this.id = id;
        this.name = name;
        this.operationInProgress = false;

        this.clearValidationErrors();

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.id = null;
        this.name = null;
        this.operationInProgress = false;

        this.clearValidationErrors();
    }

    displayValidationErrors(errors: ValidationError[])
    {
        this.errors = errors;
        this.operationInProgress = false;
    }

    clearValidationErrors()
    {
        this.errors = [];
    }
}